// extracted by mini-css-extract-plugin
export default {"title":"image-popup__title___mKHy8","image":"image-popup__image___OgaIq","bundleWithoutPackagingImage":"image-popup__bundleWithoutPackagingImage___ftjnH"};